import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 11 11", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 5.5h9M5.5 10V1", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, fill: "none" }));
export { SvgPlus as ReactComponent };
